export const SIGNIN_STATUS = 'SIGNIN_STATUS'

export const TOKEN = 'TOKEN'

export const USER_DATA = 'USER_DATA'

export const EXPIRE_TIME = 'EXPIRE_TIME'

export const TITLE = 'TITLE'

export const WEBSOCKET_PORT = 'WEBSOCKET_PORT'